fragment ContactContext on Contact {
    id
    name
    description
    emailAddresses {
        primary {
            name
        }
    }
    phones {
        primary {
            name
            value {
                numberFormatted
            }
        }
    }
}
